import EquipmentFamiliesTables from './EquipmentFamiliesTables'
import equipmentFamiliesTablesContainer from './equipmentFamiliesTablesContainer'

export default equipmentFamiliesTablesContainer(EquipmentFamiliesTables)
